import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { WarningIcon } from '@10xLabs/react-web/components/Icons/Warning'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { getBookingAmountByTickets } from 'resolvers/bookings'
import { ITotalCancellationProps } from './types'

const Warning = styled.p<TSFixMe>`
  display: flex;
  align-items: center;
  font-size: 22px;
  color: #b71c1c;
  margin: 0 0 20px;
`

const StyledWarningIcon = styled(WarningIcon)<TSFixMe>`
  fill: #b71c1c;
  width: 18px;
  height: 18px;
  margin-right: 10px;
`

const Table = styled.table<TSFixMe>`
  border-collapse: collapse;
  width: 100%;
`

const Th = styled.th<TSFixMe>`
  text-align: left;
  padding: 7px 20px;
`

const Td = styled.td<TSFixMe>`
  padding: 20px;
  background-color: #f8f9fc;
`

export const TotalCancellation = ({ booking }: ITotalCancellationProps): ReactElement => {
  const intl = useIntl()

  const { buyer } = booking
  const { total } = getBookingAmountByTickets(booking)

  const pricesCurrency = booking.currency.code === 'USD' ? 'USD' : undefined

  return (
    <div>
      <Warning>
        <StyledWarningIcon />
        <FormattedMessage
          id="bookings.cancellation.desc.title"
          defaultMessage="Are you sure you want to cancel the entire booking?"
        />
      </Warning>
      <div>
        <Table>
          <thead>
            <tr>
              <Th>
                <FormattedMessage id="bookings.cancellation.total.buyer" defaultMessage="Buyer" />
              </Th>
              <Th>
                <FormattedMessage id="bookings.cancellation.total.date" defaultMessage="Date and hour of payment" />
              </Th>
              <Th>
                <FormattedMessage id="bookings.cancellation.total.amount" defaultMessage="Amount" />
              </Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <Td>{buyer?.firstName ? `${buyer.firstName} ${buyer.lastName}` : 'N/A'}</Td>
              <Td>
                <FormattedDate
                  intl={intl}
                  value={booking.confirmedAt || booking.createdAt}
                  month="2-digit"
                  day="2-digit"
                  year="numeric"
                />{' '}
                <FormattedTimeByDate intl={intl} date={booking.confirmedAt || booking.createdAt} />
              </Td>
              <Td>
                <FormattedPrice value={total} currency={pricesCurrency} />
              </Td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  )
}
